module.exports = __webpack_public_path__ + "img/base_activites_canoe.74993d8c.svg";